// extracted by mini-css-extract-plugin
export default {"title":"_07f2783ca7","bld":"_88cd0cda79"};